import strapi, { mapStrapiData } from '../lib/strapi';
import qs from 'qs';

export const getGlobalSettings = async () => {
  try {
    const query = qs.stringify({
      populate: {
        site_logo: true,
        footer_logo: true,
        navigation_menu: { populate: '*' },
        footer_links: { populate: '*' }
      }
    }, { encodeValuesOnly: true });

    const response = await strapi.get(`/global-setting?${query}`);
    return mapStrapiData(response);
  } catch (error) {
    console.error('Global Settings API Error:', error);
    return null;
  }
};